<template>
	<div class="clearfix headerTag">
		<a class="fl back" href="javascript:history.go(-1)">返回</a>
		<span>{{headerTxt}}</span>
	</div>
</template>
<style scoped lang="less">
@import url('../../assets/less/common.less');
.headerTag{
	padding:0 0.4rem;
	text-align: center;
	height: 1.173333rem;
	line-height: 1.173333rem;
	.px2px(font-size,36px);
	background: #fff;
	.back{
		float:left;
		height: 1.173333rem;
		width:1.106667rem;
		background: url('../../assets/img/common/arror.png');
		background-size:100% 100%;
		text-indent: -99999px;
	}
	.editBtn{
		float:right;
		height: 1.173333rem;
		width:1.106667rem;
		.px2px(font-size,30px);
		border:none;
		background: none;
	}
}
</style>
<script>
	import { Toast } from 'mint-ui';
	export default {
		name: 'comparison',
		data:function() {
			return {
			}
		},
		props:["headerTxt","isButtonShow"],
		mounted: function() {
		},
		methods: {

		}
	}
</script>


// WEBPACK FOOTER //
// src/components/comparison/header.vue